export default {
  notConnected: 'Zariadenie nie je pripojené k žiadnemu podporovanému zdroju dát.',
};
